var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Breadcrumbs", { attrs: { history: _vm.history } }),
      _c("card-list", { attrs: { items: _vm.items } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }